$(document).ready(function() {
    // References to ".alertregform" class will always be applied to the container.
    // Only use "#alertreg" for stuff specific to RVC Alerts app itself and not anywhere
    // that the form will be embedded in another form.

    logMsg('Hello. Starting up the RVC Alert registration form.');

    // Initialize registration Form:
    $('.alertregform input')
        .keyup(populatePrimaryPulldown)
        .blur(populatePrimaryPulldown);
    $('.alertregform .remove').click(doRegRemove);
    $('.alertregform .cancelreg').click(doRegCancel);
    resetRegForm();

    // Form validation:
    jQueryValidationBootstrapPatch();
    $('.alertregform input[type=tel]').formatter({
        pattern: '({{999}}) {{999}}-{{9999}}'
    });
    $('#alertreg').validate({
        rules: regFormValidation.rules,
        messages: regFormValidation.messages,
        submitHandler: doRegSubmit,
        // These highlight/unhighlight functions are a little different than the Bootstrap patch standard.
        // These just look for a parent div of the input when getting to the .form-control-feedback element.
        highlight: function(element) {
            $(element)
                .closest('.form-group')
                .removeClass('has-success')
                .addClass('has-error')
                .end()
                .closest('div')
                .find('.form-control-feedback')
                .removeClass('glyphicon-ok')
                .addClass('glyphicon-remove');
        },
        unhighlight: function(element) {
            $(element)
                .closest('.form-group')
                .removeClass('has-error')
                .addClass('has-success')
                .end()
                .closest('div')
                .find('.form-control-feedback')
                .removeClass('glyphicon-remove')
                .addClass('glyphicon-ok');
        }
    });
});

// Initialize the registration form, including kicking off the AJAX to load user data from reg web service.
// Note it is only needed if you'll be doing the AJAX calls.
function initRegForm(type) {
    $('#alertreg').attr('data-type', type);
    resetRegForm();
    var parms = {
        method: 'loadInfo',
        returnFormat: 'json'
    };
    cred.injectIntoObject(parms);
    $.ajax({
        dataType: 'json',
        url: 'api/RegWebService.cfc',
        method: 'POST',
        data: parms,
        cache: false,
        success: handleLoadReg,
        error: handleLoadRegError
    });
}

// Handle reg web service errors
function handleLoadRegError(qXHR, textStatus, errorThrown) {
    try {
        $('.loginform:visible button[type=submit]').ladda('stop');
    } catch (exc) {
        logMsg("No ladda. It's ok.");
    }
    alert('Sorry, we could not load your registration! Please try again later.\n\n' + errorThrown);
    resetLoginForm();
}

// Handle populating data from reg web service into reg form
function handleLoadReg(data) {
    var which = $('#alertreg').attr('data-type');
    if (which == 'e')
        $('.remove')
            .addClass('disabled')
            .attr('title', 'As an employee, you are required to have at least one emergency contact.');
    var primary = '';
    ['Home', 'AltHome', 'Work', 'AltWork', 'Mobile', 'AltMobile', 'SMS', 'Email', 'AltEmail'].forEach(function(
        fld,
        idx
    ) {
        var newval = data.REG[fld];
        // Does number match 'primary' number? Don't match empty string or the non-telephone fields.
        if (data.REG.Primary == newval && newval != '' && idx < 6) primary = fld.toLowerCase();
        // If the field is a phone number, format the number to "(999) 999-9999" format.
        // Also, if all nines, remove the number. This is a placeholder for "nothing".
        if (typeof newval == 'number') newval = newval.toString();
        if (newval == '9999999999') newval = '';
        if (newval.length > 0 && fld.toLowerCase().indexOf('email') < 0)
            newval = '(' + newval.substr(0, 3) + ') ' + newval.substr(3, 3) + '-' + newval.substr(6, 4);
        // Set the field:
        $('#' + fld.toLowerCase()).val(newval);
    });
    populatePrimaryPulldown();
    $('#primary').val(primary);
    if ($('#primary').val() != primary) $('#primary').val('');
    $('#nonemer').prop('checked', data.REG.NonEmer || data.REG.ID == 0); // Use their NonEmer setting, or always true if this is a new registration (hence ID==0)
    $('.loginform').hide();
    $('#alertreg').show();
}

// Just the UI to clear out the reg form
function resetRegForm() {
    $('.alertregform input, .alertregform select').val('');
    $('.alertregform input[type=checkbox]').prop('checked', true);
    $('.alertregform .remove')
        .removeClass('disabled')
        .attr('title', '');
    $('.alertregform .has-feedback').removeClass('has-success has-error');
    $('.alertregform .form-control-feedback').removeClass('glyphicon-ok glyphicon-remove');
    $('.alertregform .help-block').hide();
    try {
        $('.alertregform button.ladda-button').ladda();
    } catch (exc) {
        logMsg("No ladda. It's ok.");
    }
    populatePrimaryPulldown();
}

// Calculates what options should be in the "Primary" pulldown based on input fields in "Telephone" section, and updates it accordingly
function populatePrimaryPulldown() {
    var curVal = $('#primary').val();
    var $curOptions = $('#primary option');
    var newOptions = ["<option value=''>Select Primary Number</option>"];
    // Look at all the telephone inputs, and generate all the select options.
    $('.telgroup input').each(function() {
        if (this.value.length)
            newOptions.push(
                "<option value='" +
                    this.id +
                    "'>" +
                    $(this)
                        .closest('.form-group')
                        .find('label')
                        .text()
                        .replace(':', '') +
                    '</option>'
            );
    });
    // If what we generated is a different length than what exists, replace it with what we generated.
    if ($curOptions.length != newOptions.length) {
        $curOptions.remove();
        $('#primary').append(newOptions.join(''));
        // If there's only one choice (plus the "Select Primary Number" placeholder option), automatically select it.
        if (newOptions.length == 2) $('#primary').val($('#primary :nth-child(2)').val());
        else {
            // Otherwise, try to select the same value we had previously.
            $('#primary').val(curVal);
            // If previous value couldn't be found, though, then choose the "Select Primary Number" placeholder option.
            if ($('#primary').val() != curVal) $('#primary').val('');
        }
    }
}

// Handle submitting the reg form to the reg web service
function doRegSubmit() {
    logMsg('Submit Registration!');
    try {
        $('#alertreg button[type=submit]').ladda('start');
    } catch (exc) {
        logMsg("No ladda. It's ok.");
    }
    var which = $('#alertreg').attr('data-type');
    var parms = {
        method: 'saveInfo',
        returnformat: 'json',
        usertype: which == 'nc' ? 's' : which,
        /* Non-credit (nc) is special just for JS logic. Non-credit students are still "s" type for the web service */
        primary: '',
        home: '',
        work: '',
        mobile: '',
        sms: '',
        althome: '',
        altwork: '',
        altmobile: '',
        email: '',
        altemail: '',
        fname: '',
        lname: '',
        expiredt: '',
        nonemer: null
    };
    // Add credentials
    cred.injectIntoObject(parms);
    // Pull in form values, for phone, strip to only digits
    ['home', 'althome', 'work', 'altwork', 'mobile', 'altmobile', 'sms', 'email', 'altemail'].forEach(function(fld) {
        parms[fld] = $('#' + fld).val();
        if (fld.indexOf('email') < 0) parms[fld] = parms[fld].replace(/\D/g, '');
    });
    // Specialized fields (primary, nonemer)
    var primaryFld = $('#primary').val();
    parms.primary = primaryFld == '' ? '' : parms[primaryFld];
    parms.nonemer = $('#nonemer').is(':checked');
    // Submit data
    $.ajax({
        dataType: 'json',
        url: 'api/RegWebService.cfc',
        method: 'POST',
        data: parms,
        cache: false,
        success: handleRegSubmit,
        error: handleRegError
    });
}

// Handle reg web service errors
function handleRegError(qXHR, textStatus, errorThrown) {
    try {
        $('#alertreg .ladda-button').ladda('stop');
    } catch (exc) {
        logMsg("No ladda. It's ok.");
    }
    alert('Sorry, we could not save your settings. Please try again later.\n\n' + errorThrown);
}

// Confirm the reg web service submission succeeded, and if so, proceed to confirmation screen
function handleRegSubmit(data) {
    try {
        $('#alertreg button[type=submit]').ladda('stop');
    } catch (exc) {
        logMsg("No ladda. It's ok.");
    }
    if (data) location.href = 'confirm.cfm';
    else alert('Sorry, we could not save your settings. Please try again later.');
}

// Reg screen cancel button
function doRegCancel() {
    location.href = '.';
}

// Reg screen remove button submits a remove request to the reg web service
function doRegRemove() {
    if ($(this).hasClass('disabled')) alert('As an employee, you are required to have at least one emergency contact.');
    else {
        logMsg('Registration removal!');
        if (
            confirm(
                'Are you sure you want to remove yourself from the RVC Alert service? ' +
                    'You will no longer be alerted to important RVC related events.'
            )
        ) {
            var which = $('#alertreg').attr('data-type');
            var parms = {
                method: 'removeInfo',
                returnformat: 'json'
            };
            cred.injectIntoObject(parms);
            try {
                $('#alertreg button.remove').ladda('start');
            } catch (exc) {
                logMsg("No ladda. It's ok.");
            }
            $.ajax({
                dataType: 'json',
                url: 'api/RegWebService.cfc',
                method: 'POST',
                data: parms,
                cache: false,
                success: handleRegRemove,
                error: handleRegError
            });
        }
    }
}

// Confirm the reg web service removal succeeded, and if so, proceed to removal confirmation screen
function handleRegRemove(data) {
    try {
        $('#alertreg button.remove').ladda('stop');
    } catch (exc) {
        logMsg("No ladda. It's ok.");
    }
    if (data) location.href = 'remove.cfm';
    else alert('Sorry, we could not complete your request. Please try again later.');
}
